import axios from '../utils/axios'

export function getNewsList(params){
    return axios.post(`/newMess/list`,params)
}